export default __webpack_public_path__ + "static/media/cfdLongImgCN.c466622e.png";